// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1647":"fec77224","7492":"13d108d2"}[chunkId] || chunkId) + "." + {"1647":"84b97cab843c56a5","2885":"61c4dd0ede6122f2","6823":"ae77bde38aa3441c","7433":"f38ea42c19f2fd38","7492":"bd12c3dc0f34135f","9355":"049d08ec8cd78ad8"}[chunkId] + ".js";
};